module.exports = __webpack_public_path__ + "img/2025-04.5113b05c.jpg";